/* Exit Intent Popup */
(function(){
  var showed = localStorage.getItem('oc-exit-shown');
  if(showed) return;
  document.addEventListener('mouseleave',function(e){
    if(e.clientY>0) return;
    if(localStorage.getItem('oc-exit-shown')) return;
    localStorage.setItem('oc-exit-shown','true');
    var box = document.createElement('div');
    box.id = 'oc-exit-popup';
    box.innerHTML = '<div class="oc-exit-content"><h3>Warte! 🚀</h3><p>10% Gutschein für deinen ersten Einkauf</p><input type="email" placeholder="Deine Email" id="oc-exit-email"><button id="oc-exit-submit">Gutschein sichern</button><button class="oc-close">X</button></div>';
    box.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.8);z-index:99999;display:flex;align-items:center;justify-content:center;';
    document.body.appendChild(box);
    box.querySelector('.oc-close').onclick = ()=>box.remove();
    box.querySelector('#oc-exit-submit').onclick = ()=>{ alert('Danke! Code: WELCOME10'); box.remove(); };
  });
})();